import React, {Component} from 'react';
import {connect} from "react-redux";
import {Button} from 'reactstrap';

class IdleModalComponent extends Component {

    refresh() {
        window.location.reload();
    }

    render() {
        const translations = JSON.parse(this.props.translations);

        return (
            <div id="idle-modal" className="modal" style={{display: 'none'}}>
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div id="waavo-modal-body-dynamic" className="modal-body">
                            {translations['You were inactive for 20 min. Please refresh your search.']}
                        </div>
                        <div id="waavo-modal-footer-dynamic" className="modal-footer">
                            <Button color="primary" onClick={this.refresh}>{translations['Refresh search']}</Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        idle: state.IdleReducer.idle,
        translations: ownProps.translations
    }
}

export default connect(mapStateToProps)(IdleModalComponent);



// WEBPACK FOOTER //
// ./src/components/idle/IdleModalComponent.js